export const Messages = {
    isLessThanTheMB: 'file accept less than 200kb only!',
    isLessThan50KB: 'file accept less than 50kb only!',
    OKText: 'OK',
    ErrorText: 'Error',
    SuccessText: 'Success',
    ServerErrorText: 'Server Error',
    ServerErrorMessage: 'There has been an error processing your request, please contact admin!',
    OTPSuccessSentMessage: 'OTP is sent to your mobile number.',
    OTPErrorSentMessage: 'There is an network issue. Please try again after sometime!'
};
